import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  listUserEditPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/collab/last-slide-active`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const listUserEditPresentation = async (params) => {
  const res = await resource.listUserEditPresentation(params)
  return res.body
}

export default {
  initResource,
  listUserEditPresentation,
}
